import React, { Component, Fragment, useEffect } from 'react';
import { connect } from 'react-redux';

import {
	changeAdherenceSortBy, lookUpFetchAdherences, downloadAdherences,
	searchAdherencesBy, clearSearchAdherences, searchByProtocolName,
	searchByDateRange, clearSearchByProtocol
} from '../actions';

import SearchFilters from './filters/search-filters';
import Pagination from './filters/pagination';

class AdheringPartiesLookUp extends Component {
	constructor( props ) {
		super( props );
		this.state = {
			updatePending: false,
		};
	}

	componentWillMount() {
		this.props.lookUpFetchAdherences( );
	}

	componentDidUpdate( prevProps ) {
		if ( this.props.searchTerm !== prevProps.searchTerm || this.props.pagination.perPage !== prevProps.pagination.perPage || this.props.pagination.pageNum !== prevProps.pagination.pageNum || this.props.orderBy.orderby !== prevProps.orderBy.orderby || this.props.orderBy.order !== prevProps.orderBy.order || this.props.searchBy !== prevProps.searchBy ) {
			document.getElementById('adherence-look-up-spinner').classList.remove( 'hide' );

			if ( ! this.state.updatePending ) {
				this.setState( { updatePending: true }, () => {
					setTimeout( () => {
						this.props.lookUpFetchAdherences( this.props.pagination.perPage, this.props.pagination.pageNum, this.props.searchTerm, this.props.searchBy, this.props.dateRange.startDate, this.props.dateRange.endDate, this.props.searchByProtocol );
						this.props.downloadAdherences( this.props.searchTerm, this.props.searchBy, this.props.dateRange.startDate, this.props.dateRange.endDate, this.props.searchByProtocol );

						this.setState( {
							               updatePending: false
						               }, () => {
							this.mayUpdate = true;
						} );
					}, 3000 );
				} );
			} else if ( this.mayUpdate ) {
				this.mayUpdate = false;
			}
		} else if ( this.props.searchByProtocol !== prevProps.searchByProtocol || this.props.searchDate.startDate !== prevProps.searchDate.startDate || this.props.searchDate.endDate !== prevProps.searchDate.endDate ) {
			this.props.lookUpFetchAdherences( this.props.pagination.perPage, this.props.pagination.pageNum, this.props.searchTerm, this.props.searchBy, this.props.searchDate.startDate, this.props.searchDate.endDate, this.props.searchByProtocol )
			this.props.downloadAdherences( this.props.searchTerm, this.props.searchBy, this.props.searchDate.startDate, this.props.searchDate.endDate, this.props.searchByProtocol );
		}
	}

	ifAdherenceLink( adherence ) {
		if ( adherence.link ) {
			return <p><a href={ adherence.link } target="_blank">{ adherence.participant }</a></p>;
		} else {
			return <span>{ adherence.participant }</span>;
		}
	}

	ifRevocation( adherence ) {
		if ( adherence.revoke_date !== '' && adherence.revoke_link !== '' ) {
			return(
				<Fragment>
					<a href={ adherence.revoke_link } target="_blank"><strong>Revocation Notice:</strong> Effective as of { adherence.revoke_date }</a>
				</Fragment>
			);
		} else if ( adherence.revoke_date !== '' ) {
			return(
				<Fragment>
					<strong>Revocation Notice:</strong> Effective as of { adherence.revoke_date }
				</Fragment>
			);
		}
	}

	companyNameUpdates( adherence ) {
		if ( Object.keys( adherence.company_name_doc_updated ).length > 0 ) {
			return (<Fragment>
					<strong>Name Change: </strong>
					{ adherence.company_name_doc_updated.name.map( ( name, index ) => (
						<a key={ index }
						   href={ adherence.company_name_doc_updated.link[ index ] }
						   className="rpadding"
						   target="_blank" rel="noopener noreferrer">
							{ name };
						</a>
					) ) }
				</Fragment>
			);
		}
	}

	renderTableRows( adherences ) {
		if ( adherences.status && 'error' === adherences.status ) {
			// No results.
			return (
				<Fragment>
					<div>No search results found.</div>
				</Fragment>
			);
		} else {
			document.getElementById( 'adherence-look-up-spinner' ).classList
			        .add( 'hide' );
			if ( adherences.length >= 1 ) {
				return adherences.map( adherence => {
					return (<tr key={ adherence.id } className="adh-data-row">
							<td width="35%">
								{ this.ifAdherenceLink( adherence ) }
								{ this.ifRevocation( adherence ) }
								<span className="show">
									{ this.companyNameUpdates( adherence ) }
								</span>
							</td>
							<td width="20%">{ adherence.organization_lei_cici }</td>
							<td width="25%">{ adherence.protocol_name }</td>
							<td width="20%">{ adherence.adherence_dates.acceptance_date }</td>
						</tr>
					);
				} );
			} else {
				Object.keys(adherences).map( adherence => {
					return (<tr key={ adherence.id }>
							<td width="35%">
								{ this.ifAdherenceLink( adherence ) }
								{ this.ifRevocation( adherence ) }
							</td>
							<td width="20%">{ adherence.organization_lei_cici }</td>
							<td width="25%">{ adherence.protocol_name }</td>
							<td width="20%">{ adherence.adherence_dates.acceptance_date }</td>
						</tr>
					);
				} );
			}
		}
	}

	handleSearchBy( event ) {
		let searchBy =  event.target.getAttribute( 'data-heading' );
		this.props.searchAdherencesBy( searchBy );
	}

	clickHeading( event ) {
		let orderBy = event.target.getAttribute( 'data-heading' );
		this.props.changeAdherenceSortBy( orderBy );
	}

	getSortArrow( heading ) {
		if ( this.props.orderBy.orderby === heading ) {
			return `glyphicon-arrow-${('asc' === this.props.orderBy.order
			                          ) ? 'up' : 'down'}`;
		}
	}

	handleClick( downloadAdh ) {
		//Creates CSV string from the data.
		const csvString = 'UniqueID,ProtocolName,Adhering Organization Name,Organization LEI/CICI Provided,SubmitDate,AcceptDate,RevokeDate,RevokeLink,Company Name Update,Company Name Change Letter URL\n' +
		                  ( Array.isArray( downloadAdh ) ? downloadAdh.map( adherence => (
							    `"${adherence.unique_id.replace(/"/g, '""')}",` +
							    `"${adherence.protocol_name.replace(/"/g, '""')}",` +
							    `"${adherence.participant.replace(/"/g, '""')}",` +
							    `"${adherence.organization_lei_cici.replace(/"/g, '""')}",` +
							    `"${adherence.submit_date_csv_format.replace(/"/g, '""')}",` +
							    `"${adherence.accept_date_csv_format.replace(/"/g, '""')}",` +
							    `"${adherence.revoke_date.replace(/"/g, '""')}",` +
                                `"${adherence.revoke_link.replace(/"/g, '""')}",` +
                                `"${adherence.co_name_updated.replace(/"/g, '""')}",` +
                                `"${adherence.co_name_updated_letter.replace(/"/g, '""')}"`
		                  )).join('\n') : '' );


		const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
		const url  = URL.createObjectURL(blob);

		//Create a link element and click it to trigger the download.
		const link = document.createElement('a');
		link.setAttribute('href', url);
		link.setAttribute('download', 'adherence_parties.csv');
		link.style.display = 'none';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

		//Revoke to release the memory.
		URL.revokeObjectURL(url);
	}

	getSearchResults( nextProps ) {
		this.props.lookUpFetchAdherences( nextProps.pagination.perPage, nextProps.pagination.pageNum, nextProps.searchTerm, nextProps.searchBy );
	}

	downloadLink( adherences ) {
		return (
			<button className="btn btn-default btn-download-protocol-data" onClick={() => this.handleClick( adherences )}>Download Protocol Data</button>
		);
	}

	render() {
		const searchType = 'adh-lookup';
		return (<Fragment>
				<div className="search-filter-wrapper">
					<div className="container">
						<div className="search-selection" role="group" aria-label="Search by selection">
							<button type="button"
							        className={ "btn btn-sm searchBy " + ( this.props.searchBy === 'lei' ? 'btn-primary' : 'btn-default' ) }
							        data-heading="company"
							        onClick={ this.handleSearchBy.bind( this ) }>Search by Company
							</button>
							<button type="button"
							        className={ "btn btn-sm searchBy " + ( this.props.searchBy === 'lei' ? 'btn-default' : 'btn-primary' ) }
							        data-heading="lei"
							        onClick={ this.handleSearchBy.bind( this ) }>Search by LEI
							</button>
						</div>
						{ this.props.adherences.length > 0 ?
							this.downloadLink( this.props.downloadAdh )
						: ''}

				        <SearchFilters searchType={ searchType } />
					</div>
				</div>
				<div className="container">
					<table id="protocol-adherence-parties" className="table-style-lookup" cellSpacing="0" width="100%">
						<thead>
						<tr className="table-style-header">
							<th className='has-sort'>
								<button className="btn-table-sort t-underline" onClick={ this.clickHeading.bind( this ) } data-heading="participant">
									Adhering Organization Name
									<span className={ `glyphicon ${this.getSortArrow( 'participant' )} ` } aria-hidden="true"></span>
								</button>
							</th>
							<th data-heading="lei">Organization LEI/CICI Provided
								<span className={ `glyphicon` } aria-hidden="true"></span>
							</th>
							<th data-heading="protocol">Protocol
								<span className={ `glyphicon` } aria-hidden="true"></span>
							</th>
							<th className='has-sort'>
								<button className="btn-table-sort t-underline" onClick={ this.clickHeading.bind( this ) } data-heading="acceptance">
									Acceptance Date
									<span className={ `glyphicon ${this.getSortArrow( 'acceptance' )}` } aria-hidden="true"></span>
								</button>
							</th>
						</tr>
						</thead>
						<tbody>
							{ this.renderTableRows( this.props.adherences ) }
						</tbody>
					</table>
					<Pagination />
				</div>
			</Fragment>
		);
	}
}

function mapStateToProps( { adherences, pagination, searchTerm, orderBy, searchBy, downloadAdh, dateRange, searchByProtocol, searchDate } ) {
	return { adherences, pagination, searchTerm, orderBy, searchBy, downloadAdh, dateRange, searchByProtocol, searchDate };
}

export default connect( mapStateToProps, {
	lookUpFetchAdherences, changeAdherenceSortBy, searchAdherencesBy, downloadAdherences, clearSearchAdherences, searchByProtocolName, searchByDateRange, clearSearchByProtocol
} )( AdheringPartiesLookUp );